<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Sales Target vs Realization 
                <div class="card-header-actions">
                    <button class="btn btn-primary mr-1" @click="exportxls()">
                        <i class="fa fa-file-excel-o"></i>
                        Export
                    </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="5">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="2">
                    <b-button class="btn btn-success" @click="process()" > <i class="fa fa-play"></i> Open</b-button>
                </b-col>

            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table >
                        <thead>
                            <tr>
                                <th rowspan="2" style="text-align:center;" width="300px;"> Sales Team</th>
                                <th colspan="3" style="text-align:center;" v-if="(JanShow && (filter.view=='full'))">Jan {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(FebShow && (filter.view=='full'))">Feb {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(MarShow && (filter.view=='full'))">Mar {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(AprShow && (filter.view=='full'))">Apr {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(MeiShow && (filter.view=='full'))">Mei {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(JunShow && (filter.view=='full'))">Jun {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(JulShow && (filter.view=='full'))">Jul {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(AgtShow && (filter.view=='full'))">Aug {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(SepShow && (filter.view=='full'))">Sep {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(OktShow && (filter.view=='full'))">Okt {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(NovShow && (filter.view=='full'))">Nov {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(DesShow && (filter.view=='full'))">Des {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;" v-if="(filter.view=='ytd')">{{filter.bulan}} {{filter.tahun}}</th>
                                <th colspan="3" style="text-align:center;">Year To Date</th>
                                <th colspan="3" style="text-align:center;">TOTAL</th>
                            </tr>
                            <tr>
                                <th style="text-align:center" width="100px" v-if="(JanShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(JanShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(JanShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(FebShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(FebShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(FebShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(MarShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(MarShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(MarShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(AprShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(AprShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(AprShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(MeiShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(MeiShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(MeiShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(JunShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(JunShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(JunShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(JulShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(JulShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(JulShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(AgtShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(AgtShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(AgtShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(SepShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(SepShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(SepShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(OktShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(OktShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(OktShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(NovShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(NovShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(NovShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(DesShow && (filter.view=='full'))">Target</th>
                                <th style="text-align:center" width="100px" v-if="(DesShow && (filter.view=='full'))">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(DesShow && (filter.view=='full'))">Variant </th>
                                <th style="text-align:center" width="100px" v-if="(filter.view=='ytd')">Target</th>
                                <th style="text-align:center" width="100px" v-if="(filter.view=='ytd')">Actual</th>
                                <th style="text-align:center" width="100px" v-if="(filter.view=='ytd')">Variant </th>
                                <th style="text-align:center" width="100px">Target</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                                <th style="text-align:center" width="100px">Target</th>
                                <th style="text-align:center" width="100px">Actual</th>
                                <th style="text-align:center" width="100px">Variant </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.salesae_id">
                                <td :class="row.kelas">{{row.salesae_name}}</td>
                                <td :class="row.kelas"  v-if="(JanShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget1 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(JanShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,1)">{{row.actual1| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(JanShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian1 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(FebShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget2 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(FebShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,2)">{{row.actual2| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(FebShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian2 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(MarShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget3 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(MarShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,3)">{{row.actual3| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(MarShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian3 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(AprShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget4 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(AprShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.actual4| numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(AprShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,4)">{{row.actual4| numFormat}}</b-link>                             
                                </td>

                                <td :class="row.kelas"  v-if="(MeiShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget5 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(MeiShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,5)">{{row.actual5| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(MeiShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian5 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(JunShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget6 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(JunShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,6)">{{row.actual6| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(JunShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian6 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(JulShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget7 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(JulShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,7)">{{row.actual7| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(JulShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian7 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(AgtShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget8 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(AgtShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,8)">{{row.actual8| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(AgtShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian8 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(SepShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget9 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(SepShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,9)">{{row.actual9| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(SepShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian9 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(OktShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget10 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(OktShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,10)">{{row.actual10| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(OktShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian10 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(NovShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget11 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(NovShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,11)">{{row.actual11| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(NovShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian11 | numFormat}}
                                </td>

                                <td :class="row.kelas"  v-if="(DesShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.budget12 | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(DesShow && (filter.view=='full'))" style="text-align:right">
                                    <b-link @click="drillMonthly(row,12)">{{row.actual12| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(DesShow && (filter.view=='full'))" style="text-align:right">
                                    {{row.varian12 | numFormat}}
                                </td>
                                <td :class="row.kelas" v-if="(filter.view=='ytd')" style="text-align:right">
                                    {{row.budgetmon | numFormat}}
                                </td>
                                <td :class="row.kelas"  v-if="(filter.view=='ytd')" style="text-align:right">
                                    <b-link @click="drillCurrentMonth(row)">{{row.actualmon| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas"  v-if="(filter.view=='ytd')" style="text-align:right">
                                    {{row.varianmon | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.budgetytd | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    <b-link @click="drillMonToDate(row)">{{row.actualytd| numFormat}}</b-link>                             
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.varianytd | numFormat}}
                                </td>

                                <td :class="row.kelas" style="text-align:right">
                                    {{row.budget | numFormat}}
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.actual | numFormat}}                                
                                </td>
                                <td :class="row.kelas" style="text-align:right">
                                    {{row.varian | numFormat}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <b-row class="mb-2">
                        <b-col lg="5">
                            <b-input-group>
                                <b-input-group-prepend ><span class="ml-2 mr-1 pt-1">View : </span></b-input-group-prepend>
                                <b-form-radio-group class="mt-2" v-model="filter.view" name="radioView">
                                    <b-form-radio value="ytd">Year to Date  </b-form-radio>
                                    <b-form-radio value="full">Full Coloum (12 Months)</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            <b-input-group v-if="(filter.view=='full')">
                                <b-input-group-prepend><label> &nbsp;&nbsp;&nbsp;Hide Column   :</label></b-input-group-prepend>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="JanShow" class="mt-1 mr-2" size="sm">Jan</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="FebShow" class="mt-1 mr-2" size="sm">Feb</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="MarShow" class="mt-1 mr-2" size="sm">Mar</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="AprShow" class="mt-1 mr-2" size="sm">Apr</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="MeiShow" class="mt-1 mr-2" size="sm">Mei</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="JunShow" class="mt-1 mr-2" size="sm">Jun</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="JulShow" class="mt-1 mr-2" size="sm">Jul</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="AgtShow" class="mt-1 mr-2" size="sm">Agt</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="SepShow" class="mt-1 mr-2" size="sm">Sep</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="OktShow" class="mt-1 mr-2" size="sm">Oct</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="NovShow" class="mt-1 mr-2" size="sm">Nov</b-form-checkbox>
                                <b-form-checkbox :value="false" :unchecked-value="true" v-model="DesShow" class="mt-1 mr-2" size="sm">Dec</b-form-checkbox>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </div>

            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import targetsales from "../../apis/targetsales";

import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1,layout:'', departkd:'',tahun:moment(this.$store.state.user.tglaktif).format('YYYY'), bulan:moment(this.$store.state.user.tglaktif).format('MMM'), view:'ytd'},
      lkuDeptShow:false,
      JanShow:true,
      FebShow:true,
      MarShow:true,
      AprShow:true,
      MeiShow:true,
      JunShow:true,
      JulShow:true,
      AgtShow:true,
      SepShow:true,
      OktShow:true,
      NovShow:true,
      DesShow:true,
      isLoading: false,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
  },
created: async function (){
        let tgl1 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.startOf('year').format('YYYY-MM-DD');
        this.filter.tgl2=tgl1.endOf('month') .format('YYYY-MM-DD');
        // this.filter.tahun=blnaktif.format('YYYY');
  },
methods:{
    drillMonthly: function(data,monthOf)
    {
        if (data.salesae_id) {
            // salesae_name
            var tgl1 = moment(`${this.filter.tahun}-${monthOf}-01`,'YYYY-MM-DD');
            const routeData = router.resolve({path: `sales-by-ae/${data.salesae_name}/${data.salesae_id}/${tgl1.format('YYYY-MM-DD')}/${tgl1.endOf('month').format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillCurrentMonth: function(data)
    {
        if (data.salesae_id) {
            var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            let routeData = router.resolve({path: `sales-by-ae/${data.salesae_name}/${data.salesae_id}/${tgl2.format('YYYY-MM')}-01/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillMonToDate: function(data)
    {
        if (data.salesae_id) {
            let routeData = router.resolve({path: `sales-by-ae/${data.salesae_name}/${data.salesae_id}/${this.filter.tgl1}/${this.filter.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tahun=tgl1.format('YYYY');
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                this.rptLines= await targetsales.actual(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                this.showReport=true;
                this.reportUrl= await targetsales.viewprint(this.filter);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await targetsales.actualexport(this.filter);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },

    close(){
      router.push({name: "sales.home"});
    }
  }
};
</script>
